<template>
  <div id="app-wrapper" :class="{ 'light-mode': !isDarkMode, 'sidebar-expanded': isSidebarExpanded }">
    <nav id="sidebar">
      <div class="sidebar-header mt-3">
        <!-- <img src="https://i.pravatar.cc/150?img=68" alt="User Avatar" class="rounded-circle user-avatar-icon" /> -->
        <img v-if="UserProf != null && UserProf.length > 0" :src="'data:image/jpeg;base64, ' + UserProf" class="rounded-circle user-avatar-icon" alt="User Avatar" />
        <div class="spinner-grow text-lable" style="width: 2rem; height: 2rem" role="status" v-else>
          <span class="sr-only">Loading...</span>
        </div>
        <div class="user-info">
          <small class="text-secondary d-block">{{ userRole }}</small>
          <h6 class="fw-bold mb-0 mt-2 mb-2">{{ User.name + " " + User.family }}</h6>
          <small class="mt-2 fw-bold">امروز : {{ $GetJalaliDate() }}</small>
        </div>
      </div>

      <div class="sidebar-menu-scroll">
        <ul class="nav flex-column ps-0 py-3" style="margin-bottom: 50px">
          <li class="nav-item">
            <router-link to="/Dashbord" class="nav-link">
              <i class="fa fa-home ms-3"></i>
              <span>داشبورد اصلی</span>
            </router-link>
          </li>

          <!-- <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="toggleTheme">
              <i :class="['fa', isDarkMode ? 'fa-brush ms-3' : 'fa-brush ms-3']"></i>
              <span>{{ isDarkMode ? "تم روشن" : "تم تیره" }}</span>
            </a>
          </li> -->

          <li class="nav-item" v-for="(item, key) in Menus" :key="key">
            <router-link :to="{ name: item.routeMenu }" class="nav-link" active-class="active">
              <i class="ms-3" :class="item.icon"></i>
              <span>{{ item.persianName }}</span>
            </router-link>
          </li>

          <!-- <li class="nav-item">
            <a class="nav-link" :class="{ active: activeMenu === 'users' }" @click.prevent="toggleMenu('users')">
              <i class="fal fa-users ms-3"></i>
              <span>مدیریت کاربران</span>

              <i class="fal fa-chevron-left sub-menu-arrow" :class="{ 'rotate-down': activeMenu === 'users' }"></i>
            </a>

            <transition name="expand">
              <div class="sub-menu" v-show="activeMenu === 'users'">
                <router-link to="/users/list" class="nav-link" active-class="active">
                  <i class="fa fa-circle ms-3" style="font-size: 8px"></i>
                  <span>لیست کاربران</span>
                </router-link>

                <router-link to="/users/access" class="nav-link" active-class="active">
                  <i class="fa fa-circle ms-3" style="font-size: 8px"></i>
                  <span>سطوح دسترسی</span>
                </router-link>

                <router-link to="/users/register" class="nav-link" active-class="active">
                  <i class="fa fa-circle ms-3" style="font-size: 8px"></i>
                  <span>ثبت نام جدید</span>
                </router-link>
              </div>
            </transition>
          </li> -->
        </ul>
      </div>
    </nav>

    <div id="content" @click="closeSidebarMobile">
      <nav class="navbar navbar-expand-lg navbar-dark sticky-top mb-4">
        <div class="container-fluid">
          <h6 v-if="JSON.parse(this.$GetCookies('customer')).nameOfSchool==null">Logic Line دستیار حرفه شما</h6>
          <h6 v-else>{{ JSON.parse(this.$GetCookies('customer')).nameOfSchool }}</h6>

          <div class="">
            <h4 class="d-inline" @click="toggleTheme"><i class="fas fa-brush text-secondary Pointer" title="تغییر حالت تم"></i></h4>
            <h4 class="d-inline pe-3" @click="PowerOff"><i class="fas fa-power-off text-secondary Pointer" title="خروج کاربر"></i></h4>
          </div>
          <button type="button" class="btn btn-outline-light d-lg-none me-3" @click.stop="isSidebarExpanded = !isSidebarExpanded">
            <i class="fa fa-bars"></i>
          </button>
        </div>
      </nav>

      <main class="">
        <router-view />
      </main>
      <footer class="footer-dashboard py-2 px-4 ">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-md-8 text-center text-md-end text-muted">
              <small>
                1405 &copy; کلیه حقوق این وب‌سایت، شامل طراحی، توسعه و محتوای آن، متعلق به تیم Logic Line می‌باشد. هرگونه کپی‌برداری غیرمجاز پیگرد قانونی دارد. |
                <span class="text-lable fw-bold">سامانه هوشمند آموزشگاه های زبان</span>
              </small>
            </div>
            <div class="col-md-4 text-center text-md-start mt-2 mt-md-0">
              <small class="">
                طراحی و توسعه توسط تیم :
                <a href="#" class="text-decoration-none developer-link">LTwo.ir</a>
                <i class="fas fa-code ms-1 text-lable mx-1"></i>
              </small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      CName:null,
      isDarkMode: true,
      isSidebarExpanded: false, // در شروع کار بسته باشد تا روی محتوا را نگیرد
      activeMenu: null,

      Menus: [],
      UserProf: null,
      userRole: null,
    };
  },
  methods: {
    toggleTheme() {
      // اول مقدار داخلی را تغییر می‌دهیم تا آیکون‌ها در لحظه عوض شوند
      this.isDarkMode = !this.isDarkMode;

      // ذخیره در لوکال استوریج
      const theme = this.isDarkMode ? "dark" : "light";
      localStorage.setItem("theme", theme);

      // اعمال کلاس به body برای تغییر استایل‌های CSS
      this.applyTheme(theme);
    },

    applyTheme(theme) {
      if (theme === "light") {
        document.body.classList.add("light-mode");
        // اگر از کلاس انیمیشن بک‌گراند استفاده می‌کنید، آن را مدیریت کنید
      } else {
        document.body.classList.remove("light-mode");
      }
    },

    toggleMenu(menu) {
      this.activeMenu = this.activeMenu === menu ? null : menu;
    },

    closeSidebarMobile() {
      if (window.innerWidth < 992) {
        this.isSidebarExpanded = false;
      }
    },

    GetUserProf() {
      let User = this.$getUser();
      var k = this.$CreateKey({ DateNow: this.$GetJalaliDate(), UserId: User.id });
      this.$PostData("Post", "DashbordData/UserProf", k, false).then((res) => {
        if (res.success == true) {
          this.UserProf = res.data.img;
          this.userRole = res.data.userRole;
        }
      });
    },
    PowerOff() {
      this.$SweetQustion("خروج", " آیا از خروج ، داشبورد اطمینان دارید؟ ", "question", "بلــه ", "خیر", null, this.Exit, this.cancel);
    },
    cancel() {},
    Exit() {
      this.$RemoveCookies("token");
      this.$RemoveCookies("user");
      this.$RemoveCookies("menus");
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    const savedTheme = localStorage.getItem("theme") || "dark";
    this.isDarkMode = savedTheme === "dark";
    this.applyTheme(savedTheme);
    this.GetUserProf();
  },
  created() {
    let coc = JSON.parse(this.$GetCookies("user"));    
    this.CName=JSON.parse(this.$GetCookies("customer")).nameOfSchool
    if (coc && coc.id > 0) {
      this.User = this.$getUser();
      let restoredArray = this.$ReadArrayFromCookies();
       restoredArray = this.$GetArray();
      let arr = restoredArray.filter((x) => x.isMenu == true);
      this.Menus=arr.sort((a, b) => a.index - b.index);
    } else {
      this.Exit();
    }
  },
};
</script>

<style>
:root {
  --form-bg: rgba(7, 7, 7, 0.13);
  --form-input-bg: rgba(7, 7, 7, 0.13);
  --form-text: #ffffff;
  --form-border: rgba(255, 255, 255, 0.1);
  --form-label: #adb5bd;
  --modal-body: rgba(49, 49, 49, 0.863);
  --modal-body2: rgba(34, 34, 34, 0.938);
  --modal-glasses: rgba(36, 36, 36, 0.596);
  --modal-border-glasses: rgba(255, 255, 255, 0.1);
  --date-time-text: #cecccc;
  --date-time-bg: rgba(43, 43, 49, 0.938);
  --card-lable-dashbord: #f59e0b;
  --Transaction-header: #616266a8;
  --footer-bg:rgba(0, 0, 0, 0.473);
}
/* حالت روشن (Light) */
body.light-mode {
  --form-bg: #f0f0f0;
  --form-input-bg: #f8f9fa;
  --form-text: #2d3436;
  --form-border: #cfcece;
  --form-label: #464d50;
  --modal-body: #ffffff;
  --modal-body2: #dddddd;
  --modal-glasses: rgba(250, 250, 250, 0.541);
  --modal-border-glasses: rgba(82, 81, 81, 0.26);
  --date-time-text: #585858;
  --date-time-bg: #f8f9fa;
  --card-lable-dashbord: #3b82f6;
  --Transaction-header: #c6c6c7;
  --footer-bg:#f1f1f1;
}

.form-container,
.card,
th,
tr,
td,
.badge {
  background-color: var(--form-bg) !important;
  color: var(--form-text) !important;
  border: 1px solid var(--form-border) !important;
  transition: all 0.3s ease;
}
span:not(button span) {
  color: var(--form-text);
}
small,
::placeholder,
b {
  color: var(--form-label) !important;
}

/*برای رنگ دیت پیکر ها */
.vpd-container span,
.vpd-weekday,
.vpd-month-label,
.vpd-actions button {
  color: var(--date-time-text) !important;
}
.vpd-header,
.vpd-header span {
  color: #f8f9fa !important;
}
.vpd-body,
.vpd-addon-list,
.vpd-addon-list-item,
.vpd-addon-list-content {
  background-color: var(--date-time-bg) !important;
}
.vpd-addon-list-item {
  border: none !important;
}

/* اعمال به اینپوت‌ها و سلکتورها */
input,
textarea,
.card-body {
  background-color: var(--form-bg) !important;
  color: var(--form-text) !important;
  border: 1px solid var(--form-border) !important;
}

.BG {
  background-color: var(--modal-body) !important;
  color: var(--form-text) !important;
}

select {
  background-color: var(--form-input-bg) !important;
  color: var(--form-text) !important;
  border: 1px solid var(--form-border) !important;
  appearance: none; /* حذف فلش پیش‌فرض برای کنترل بهتر */
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 8px 12px !important;
  cursor: pointer;
}
/* حالت دارک */
body:not(.light-mode) select option {
  background-color: #2c3e50 !important; /* رنگ تیره ثابت */
  color: #ffffff !important;
}
/* حالت لایت */
body.light-mode select option {
  background-color: #ffffff !important; /* رنگ سفید ثابت */
  color: #333333 !important;
}
/* رفع مشکل در سیستم‌عامل‌های مک و موبایل */
select:focus {
  outline: none;
  border-color: #1e90ff !important;
}
.text-lable {
  color: var(--card-lable-dashbord) !important;
}
</style>

<style>
/* فونت و پایه */
#app-wrapper {
  font-family: "IRANSansWeb", "Nahid", sans-serif !important;
  min-height: 100vh;
  transition: all 0.5s ease;
  direction: rtl;
  overflow-x: hidden;
}
#sidebar .nav {
  padding-right: 0 !important;
  list-style: none;
}

#sidebar .nav-link {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important; /* چسبیدن محتوا به راست */
  direction: rtl !important;
  padding: 12px 15px !important;
  margin: 8px 5px !important;
  color: #ced4da !important;
  text-decoration: none !important;
  border-radius: 12px !important;
  cursor: pointer !important;
}

/* استایل دقیق آیکون (باید چسبیده به راست باشد) */
#sidebar .nav-link i.fa {
  font-size: 18px !important;
  min-width: 25px !important; /* ایجاد فضای ثابت برای آیکون */
  text-align: center !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-left: 12px !important; /* فاصله آیکون از متن سمت چپش */
  margin-right: 0 !important; /* چسبیدن به دیواره راست */
}

#sidebar .nav-link span {
  font-size: 13px !important;
  white-space: nowrap !important;
  letter-spacing: 0 !important;
}

/* فلش بازشونده زیرمنو */
.sub-menu-arrow {
  margin-right: auto !important; /* هل دادن فلش به دورترین نقطه سمت چپ */
  margin-left: 0 !important;
  font-size: 10px !important;
}

/* زیرمنوها */
.sub-menu {
  padding-right: 30px !important; /* تو رفتگی زیرمنو از سمت راست */
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* آیکون‌ها */
#sidebar .nav-link i.me-2 {
  font-size: 17px !important;
  min-width: 40px !important; /* این بخش برای تراز شدن متن‌ها حیاتی است */
  text-align: center !important;
  margin-left: 0.5rem !important;
  margin-right: 0 !important; /* چون RTL هستیم */
}

#sidebar .nav-link span {
  font-size: 13px !important;
  white-space: nowrap !important;
}

/* حالت Hover و Active (آبی حرفه‌ای شیشه‌ای) */
#sidebar .nav-link:hover,
#sidebar .nav-link.active {
  color: #fff !important;
  background-color: rgba(30, 144, 255, 0.4) !important;
}

/* استایل زیرمنوها */
.sub-menu {
  padding-right: 15px !important;
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  margin-right: 20px;
}

.sub-menu .nav-link {
  background-color: transparent !important;
  font-size: 0.95rem !important;
  color: #adb5bd !important;
}

/* فلش کنار منوهای بازشونده */
.sub-menu-arrow {
  font-size: 10px !important;
  transition: transform 0.3s ease;
}

.nav-link:not(.collapsed) .sub-menu-arrow {
  transform: rotate(-90deg);
}

/* تم لایت */
.light-mode #sidebar .nav-link {
  color: #495057 !important;
}

.light-mode #sidebar .nav-link:hover,
.light-mode #sidebar .nav-link.active {
  color: #212529 !important;
  background-color: rgba(30, 144, 255, 0.2) !important;
}

/* انیمیشن بک‌گراند دارک */
#app-wrapper:not(.light-mode) {
  background: linear-gradient(135deg, #2a3c58, #444f61);
  background-size: 300% 800vh;
  animation: backgroundShift 15s ease infinite;
  color: #f8f9fa;
}

@keyframes backgroundShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

body.sidebar-expanded {
  /* کلاس ثابت برای تنظیم اولیه */
}

/* ************ Sidebar Glassmorphism (RTL) - Dark Mode ************ */
#sidebar {
  width: 280px;
  height: calc(100vh - 65px);
  background-color: rgba(0, 0, 0, 0.473);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);

  position: fixed;
  right: 20px;
  top: 20px;
  bottom: 20px;

  z-index: 1030;
  overflow: hidden;
  padding: 10px;
  transition: all 0.5s ease;
}

/* ************ بخش Header کاربر (ثابت) ************ */
.sidebar-header {
  padding: 10px 0;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 20px;
  position: relative;
}

/* ************ بخش جدید برای اسکرول منوها (Dark Mode) ************ */
.sidebar-menu-scroll {
  height: calc(100% - 220px);
  overflow-y: auto;
  padding: 0 5px 10px 5px;

  /* ************ استایل Scrollbar فایرفاکس ************ */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

/* ************ استایل Scrollbar WebKit (اعمال روی بخش اسکرول) ************ */
.sidebar-menu-scroll::-webkit-scrollbar {
  width: 8px;
}

.sidebar-menu-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.1);
}

.sidebar-menu-scroll::-webkit-scrollbar-track {
  background-color: transparent;
}

/* عکس کاربر (Dark Mode) */
.user-avatar-icon {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 2px solid #ff831e;
  padding: 2px;
  box-shadow: 0 0 10px rgba(255, 139, 30, 0.699);
  transition: all 0.3s;
  margin-bottom: 10px;
}

.user-info {
  display: block;
  padding-top: 5px;
}

/* ************ آیتم‌های منو و زیرمنو (Dark Mode) ************ */
.nav-link {
  color: #ced4da;
  padding: 12px 10px;
  margin: 8px 5px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  font-weight: normal;
  transition: all 0.2s ease;
}

.nav-link i.me-2 {
  font-size: 17px;
  min-width: 40px;
  text-align: center;
  margin-left: 0.5rem !important;
}

.nav-link span {
  display: inline;
  white-space: nowrap;
}

/* ***** استایل هاور و اکتیو (آبی حرفه‌ای) - Dark Mode ***** */
.nav-link:hover,
.nav-link.active {
  color: #fff;
  background-color: rgba(30, 144, 255, 0.4);
  font-weight: normal;
}

.nav-link.active {
  padding-right: 9px;
}

/* استایل زیرمنوها (Dark Mode) */
.sub-menu {
  padding-right: 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 5px;
  padding-bottom: 5px;
}
.sub-menu .nav-link {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 0.95rem;
  color: #adb5bd;
  background-color: transparent !important;
  box-shadow: none;
}
.sub-menu .nav-link:hover {
  color: #fff;
  background-color: rgba(30, 144, 255, 0.2) !important;
}

/* ************ محتوای اصلی ************ */
#content {
  margin-right: 300px;
  padding: 20px;
  transition: all 0.5s ease;
}

/* ************ استایل Glass Card (Dark Mode) ************ */
.glass-card {
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  padding: 25px;
}
.glass-card .card-header {
  background-color: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 15px;
  padding: 0 0 10px 0;
}
.glass-card .card-body {
  padding: 0 !important;
}

/* ************ تم لایت (LIGHT MODE) ************ */
body.light-mode {
  /* پس‌زمینه روشن */
  background: linear-gradient(135deg, #f0f4f8, #e0e8f0, #f0f4f8);
  color: #212529; /* رنگ متن تیره */
}

body.light-mode #sidebar {
  /* سایدبار شیشه‌ای روشن */
  background-color: rgba(235, 235, 235, 0.7);
  border: 1px solid rgba(63, 63, 63, 0.1);
  box-shadow: 0 8px 32px 0 rgba(49, 49, 49, 0.199);
}

/* ************ استایل Glass Card (Light Mode) ************ */
body.light-mode .glass-card {
  background-color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
}
body.light-mode .glass-card .card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* ************ اسکرول‌بار در تم لایت ************ */
body.light-mode .sidebar-menu-scroll {
  /* رنگ اسکرول‌بار روشن */
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

body.light-mode .sidebar-menu-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

body.light-mode .sidebar-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* آیتم‌های منو در تم لایت (اصلاح شده) */
body.light-mode .nav-link {
  color: #1f2124;
}

/* هاور و اکتیو در تم لایت (اصلاح شده) */
body.light-mode .nav-link:hover,
body.light-mode .nav-link.active {
  color: #212529;
  background-color: rgba(30, 144, 255, 0.2);
}

body.light-mode .nav-link.active {
  /* border-right: 3px solid #1E90FF;  */
}

/* زیرمنوها در تم لایت */
body.light-mode .sub-menu {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
body.light-mode .sub-menu .nav-link {
  color: #6c757d;
}
body.light-mode .sub-menu .nav-link:hover {
  color: #212529;
  background-color: rgba(30, 144, 255, 0.1) !important;
}

/* عکس کاربر در تم لایت */
body.light-mode .user-avatar-icon {
  border: 2px solid #1e90ff;
  box-shadow: 0 0 10px rgba(30, 143, 255, 0.575);
}

/* ************ ریسپانسیو (موبایل) ************ */
@media (max-width: 991.98px) {
  #sidebar {
    width: 280px !important;
    right: -300px !important; /* سایدبار را به بیرون از صفحه می‌برد */
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    border-radius: 0 !important;
    margin-right: 0 !important; /* حذف مارجین اضافی */
    position: fixed !important;
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    background-color: rgba(0, 0, 0, 0.95) !important;
    z-index: 2000 !important;
  }

  /* وقتی کلاس sidebar-expanded فعال شد، سایدبار را نمایش بده */
  #app-wrapper.sidebar-expanded #sidebar {
    right: 0 !important;
  }

  #content {
    margin-right: 0 !important;
  }

  /* استایل سایدبار در تم لایت (موبایل) */
  body.light-mode #sidebar {
    background-color: rgba(255, 255, 255, 0.98) !important;
    border-left: 1px solid #ddd !important;
  }
}
.nav-link span {
  font-size: 13px;
}
.nav-link i {
  font-size: 10px;
}
/* تنظیمات کلی لینک برای پشتیبانی از چیدمان جدید */
.nav-link {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important; /* محتوا از راست شروع شود */
  padding: 12px 15px !important;
  direction: rtl !important;
}

/* آیکون اصلی سمت راست */
.nav-link i.fa:not(.sub-menu-arrow) {
  min-width: 25px !important;
  margin-left: 15px !important; /* فاصله آیکون از متن سمت چپ */
  margin-right: 0 !important;
  text-align: center;
}

/* متن منو */
.nav-link span {
  flex-grow: 0; /* متن فقط به اندازه خودش فضا بگیرد */
}

/* فلش منوی کشویی - چسبیده به سمت چپ */
.sub-menu-arrow {
  margin-right: auto !important; /* هل دادن به منتهی‌الیه سمت چپ در RTL */
  margin-left: 0px !important; /* کمی فاصله از لبه سایدبار برای زیبایی */
  font-size: 11px !important;
  transition: transform 0.3s ease !important;
}

/* کلاس کمکی برای چرخش فلش هنگام باز شدن */
.rotate-down {
  transform: rotate(-90deg);
}

/* استایل زیرمنو برای حفظ ساختار درختی */
.sub-menu {
  margin-right: 20px !important; /* فاصله کل زیرمنو از سمت راست سایدبار */
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding-right: 10px !important;
}

.sub-menu .nav-link {
  margin: 0px 0 !important;
}
</style>


<style scoped>
/* / تنظیمات بدنه برای چسبیدن فوتر / */
.footer-dashboard {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  font-size: 0.85rem; 
  background: var(--footer-bg) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-top-left-radius:60px ;
  border-top-right-radius:60px ;
}

/* / افکت روی نام توسعه‌دهنده / */
.developer-link {
  color: var(--card-lable-dashbord);
  font-weight: 600;
  transition: color 0.3s ease;
}

.developer-link:hover {
  /* color: var(--card-lable-dashbord); */
}



@media (max-width: 768px) {
  .footer-dashboard {
    font-size: 0.75rem;
    display: none;
  }
}
</style>
